import color from '@deprecated-ui/_style/color';
import { Button, Flex, Modal, Text } from '@deprecated-ui/common';
import RegisterTradingModal from 'features/securities/AuthModal/RegisterTradingModal';
import If from 'global/Common/If';
import Image from 'global/Image';
import { BaseModalProps } from 'global/Modal/BaseModal';

import { FC, useState } from 'react';

const ChatLimitModal: FC<BaseModalProps> = (props) => {
  const [openSekuritas, setOpenSekuritas] = useState(false);
  const { visible, onCancel } = props;
  return (
    <>
      <If condition={visible && !openSekuritas}>
        <Modal
          width={400}
          visible={visible && !openSekuritas}
          hideHeader
          {...props}
        >
          <Flex
            direction="column"
            padding="60px 20px 20px 20px"
            style={{ gap: 24 }}
            align="center"
            justify="center"
          >
            <Image
              src="/illustration/chat-limit.svg"
              width={160}
              height={120}
            />

            <Flex
              direction="column"
              style={{ gap: 12 }}
              align="center"
              justify="center"
            >
              <Text
                size="17px"
                weight="700"
                align="center"
                color={color.highempahis}
              >
                Chat Limit Reached
              </Text>
              <Text align="center" size="14px" weight="400" color="#858585">
                You’ve Reached Your Daily Limit. Wait until tomorrow to start a
                new chat or open a Stockbit Sekuritas Account to remove your
                limit.
              </Text>
            </Flex>

            <Button
              width="100%"
              color="green"
              type="primary"
              style={{ padding: 12, borderRadius: 3 }}
              onClick={() => setOpenSekuritas(true)}
            >
              <Text weight="700" color="#fff" size="14px">
                Open Stockbit Sekuritas Account
              </Text>
            </Button>
          </Flex>
        </Modal>
      </If>
      <If condition={visible && openSekuritas}>
        <RegisterTradingModal
          visible={visible && openSekuritas}
          onClose={onCancel}
        />
      </If>
    </>
  );
};

export default ChatLimitModal;
